import React from 'react'
import classes from './styles.module.scss'

export default class WingBlank extends React.Component {
  // constructor (props) {
  //   super(props)
  //   this.state = {
  //     foo: 'foo'
  //   }
  // }
  render() {
    const { size = 'lg', children, className = '' } = this.props
    return (
      <div className={`${classes.componentsWingBlank} ${className}`} data-size={size}>
        {children}
      </div>
    )
  }
}
